import React, {useContext} from "react";
import "./Team.css";
import {teamSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Team() {
  const {isDark} = useContext(StyleContext);
  
  if (!teamSection.display) {
    return null;
  }
  
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="team">
        <div>
          <h1 className="skills-heading">{teamSection.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {teamSection.subtitle}
          </p>

          <div className="team-members-container">
            {teamSection.members.map((member, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode team-member-card team-member-card-dark"
                      : "team-member-card team-member-card-light"
                  }
                >
                  <div className={`member-image-container member-role-${member.roleType}`}>
                    <img
                      src={member.image}
                      alt={member.name}
                      className="member-image"
                    />
                  </div>
                  <div className="member-info">
                    <h3 className="member-name">{member.name}</h3>
                    <p className={isDark ? "dark-mode member-position" : "member-position"}>
                      {member.position}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
